<template>
    <ProductCard @click="selectProduct" :pointer="!showWizard">
        <div :class="{'tw:grid tw:grid-cols-1 tw:md:grid-cols-3 tw:gap-0 tw:md:gap-8': showWizard}">
            <div class="tw:order-2 tw:md-order-1">
                <ProductImage :imageSrc="item.image" :altText="item.title"/>
                <ProductDescription :title="item.title" :description="item.description" :tags="item.tags"/>
                <ContentWrapper v-if="item.packageContent && item.packageContent.length">
                    <h4 class="tw:mb-2 tw:text-xs tw:font-medium tw:uppercase tw:text-zinc-500">{{ $t('Innhold') }}</h4>
                    <ul class="tw:space-y-2 tw:pl-1 tw:mb-0">
                        <li v-for="(content, i) in visibleItems" :key="i" class="tw:flex tw:items-center tw:justify-between">
                            <div class="tw:flex tw:items-center tw:gap-2 tw:min-w-0">
                                <span class="tw:h-1.5 tw:w-1.5 tw:flex-none tw:rounded-full tw:bg-zinc-400"></span>
                                <span class="tw:truncate tw:text-sm tw:text-zinc-800" :title="content.title">
                                    {{ content.title }}
                                    <span v-if="Number(content.qty) > 1" class="tw:text-zinc-500">× {{ content.qty }}</span>
                                </span>
                            </div>
                            <div class="tw:text-right tw:text-sm tw:tabular-nums">
                                <span v-if="content.has_discount && content.standalone_price"
                                      class="tw:mr-2 tw:text-zinc-500 tw:line-through">{{ content.standalone_price }}</span>
                                <span class="tw:font-medium tw:text-zinc-900 tw:whitespace-nowrap">{{ content.price }}</span>
                            </div>
                        </li>
                    </ul>
                </ContentWrapper>
    
                <ProductFooter>
                    <ProductPrice :price="item.price" :compareAt="item.compareAt" :discountInPercent="item.discountInPercent" :shippingCost="item.deliveryFeeAmount"/>
                </ProductFooter>
            </div>
            <div v-if="showWizard" class="tw:col-span-2 tw:order-1 tw:md:order-2 tw:mb-4 tw:md:mb-0">
                <InlineBookingWizard/>
            </div>
        </div>
    </ProductCard>
</template>

<script setup>
    import {computed, ref} from 'vue'
    import ProductCard from './product/cardWrapper.vue'
    import ProductDescription from './product/description.vue'
    import ProductPrice from './product/price.vue'
    import ProductImage from "./product/image.vue";
    import ProductFooter from "./product/footerWrapper.vue";
    import ContentWrapper from './product/contentWrapper.vue';
    import InlineBookingWizard from './inlineBookingWizard.vue';

    import { useWebShopStore } from './webshopState';
    const webShopState = useWebShopStore();
    const {item} = defineProps({
        item: {type: Object, required: true},
        showWizard: {type: Boolean, default: false},
    })
    const initialCount = 5
    const expanded = ref(false)
    const visibleItems = computed(() => {
        const list = Array.isArray(item?.packageContent) ? item.packageContent : []
        return expanded.value ? list : list.slice(0, initialCount)
    })

    const selectProduct = () => {
        webShopState.selectProduct(item)
    }
</script>
